import React, { useEffect, useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Td from "../Components/Td";
import getLeaveType from "../../../utilities/getLeaveType";
import getStatus from "../../../utilities/getStatus";
import changeDateFormat from "../../../utilities/changeDateFormat";
import RowFilter from "../../../utilities/RowFilter";
import emailIcon from "../../../assets/images/emailIcon.png";
import emptyIcon from "../../../assets/icons/empty-set.png"
import telIcon from "../../../assets/images/telIcon.png";
import setTextForm from "../../../utilities/setTextForm";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import {
  approveLeaveRequest,
  acceptNegotiation,
  rejectNegotiation,
  deleteLeave,
} from "../../../slices/leave";

import {
  approveAuthorisation,
  deleteAuthorisation,
} from "../../../slices/authorisation";
import { deleteHeadquarter } from "../../../slices/headquarter";
import { useDispatch, useSelector } from "react-redux";
import CollapseComponent from "./Collapse";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { closeModal, openModal } from "../../../slices/modals";
import deleteIcon from "../../../assets/icons/rubbish.png";
import editIcon from "../../../assets/icons/Edit.png";
import Avatar from "@mui/material/Avatar";
import { deleteLeaveType } from "../../../slices/leavetype";
import Tooltip from "@mui/material/Tooltip";
import getAccess from "../../../utilities/getAccess";
import pluralHandler from "../../../utilities/pluralHandler";
import { getFormattedDate } from "../../../utilities/getFormattedDate";
import { toast } from "react-toastify";
import { changeOneDateFormat } from "../../../utilities/changeOneDateFormat";

const Row = ({
  row,
  tableName,
  isAction,
  allowed,
  sortBy,
  getLeaveStatus,
  isCollapsed,
  isMySpace,
  isAuthorisation,
  setNotice,
  leaveID,
  page,
  getRemoteRequestStatus,
  onApprove,
  onReject,
  onDelete,
  isEmployee,
  isTeamLead,
  isRH,
}) => {
  const [open, setOpen] = useState(false);
  const [leaveDate] = useState([]);
  
  useEffect(() => {
    page && setOpen(false);
  }, [page]);
  
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.fetchMe);
  
  // Use the passed props or calculate from user role
  const userIsTeamLead = isTeamLead !== undefined ? isTeamLead : user?.role?.code === "TEAM LEAD";
  const userIsRH = isRH !== undefined ? isRH : user?.role?.code === "RH";
  
  const authorisationDetails = tableName === "authorisations" ? row : true;

  const filteredRow = RowFilter(
    allowed,
    tableName === "leaves" ?
      { ...row, balance:  row?.balanceAtApproval?.toFixed(2) || row?.user?.balanceLeft?.toFixed(2) }
      :
      tableName === "authorisations" ?
      { 
        ...row, 
        balanceStatus: row?.isUsed
      }
      : row,
    tableName,
    sortBy
  );

  const approveRequestHandler = () => {
    if (tableName === "remoteRequests") {
      onApprove && onApprove(row._id);
    } else if (!isAuthorisation) {
      dispatch(approveLeaveRequest(row?._id)).then(() => {
        if (row.user.balanceLeft < row?.leaveLength) {
          setNotice({
            text: `User will be negative with ${Math.abs(
              row.user.balanceLeft - row?.leaveLength
            ).toFixed(2)}`,
            open: true,
            state: "error",
          });
        }
      });
    } else {
      dispatch(approveAuthorisation(row?._id)).then((res) => {
        if (res.error) {
          setNotice({
            text: res.error.message,
            open: true,
            state: "error",
          });
        }
      });
    }

    // Removed automatic tab switching - users stay on current tab
  };


  const acceptNegotiationHandler = () => {
    dispatch(acceptNegotiation(row?._id));
    // Removed automatic tab switching - users stay on current tab
  };

  const rejectNegotiationHandler = () => {
    dispatch(rejectNegotiation(row?._id));
    // Removed automatic tab switching - users stay on current tab
  };

  const deleteLeaveHandler = () => {
    isAuthorisation
      ? dispatch(deleteAuthorisation(row?._id))
      : dispatch(deleteLeave(row?._id));
    dispatch(closeModal("confirm-delete-modal"));
    setNotice({
      text: isAuthorisation
        ? "Authorisation  is successfully deleted!"
        : "Leave  is successfully deleted!",
      open: true,
      state: "success",
    });
  };

  const deleteLeaveTypeHandler = () => {
    dispatch(deleteLeaveType(row?._id));
    dispatch(closeModal("confirm-delete-modal"));
    setNotice({
      text: "Leave type is successfully deleted!",
      open: true,
      state: "success",
    });
  };
  return (
    <React.Fragment>
      <TableRow
        className={row._id === leaveID ? "selected-leave" : ""}
        sx={{
          "& > *": {},
        }}
      >
        {Object.entries(filteredRow).map((el, key) => {
          return (
          <React.Fragment key={key}>
            <TableCell
              className={tableName === "leave-types" ? "leave-types-table" : ""}
              onClick={() =>
                row?.status?.code === "rejected"
                  ? dispatch(
                      openModal("RejectLeaveRequestModal", {
                        rejectAuthDetails:
                          isAuthorisation || tableName === "authorisations"
                            ? true
                            : false,
                        rejectDetails:
                          isAuthorisation || tableName === "authorisations"
                            ? false
                            : true,
                        getLeaveStatus: getLeaveStatus,
                        id: row?._id,
                        row: row,
                      })
                    )
                  : tableName === "authorisations"
                  ? dispatch(
                      openModal("ApplyForAuthorisationModalDetails", {
                        ...row,
                        authorisationDetails,
                      })
                    )
                  : tableName === "leave-types" &&
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "LEAVE TYPE",
                      "VIEW"
                    )
                  ? dispatch(openModal("UpdateLeaveSettingsModal", row))
                  : tableName === "leaves"
                  ? row?.status?.code === "waiting-employee-negotiate"
                    ? dispatch(openModal("ApplyForNegotiationModal", row))
                    : getAccess(
                        user?.permissions,
                        user?.permissionGroups?.[0]?.permissions,
                        "LEAVE",
                        "LIST"
                      ) ||
                      getAccess(
                        user?.permissions,
                        user?.permissionGroups?.[0]?.permissions,
                        "LEAVE",
                        "CREATE"
                      )
                    ? dispatch(openModal("ApplyForLeaveDetailsModal", row))
                    : ""
                  : tableName === "users" &&
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "USER",
                      "VIEW"
                    )
                  ? dispatch(openModal("EmpDetModal", { id: row?._id }))
                  : tableName === "remoteRequests"
                  ? (() => {
                      // Check if user can edit this remote request
                      // Only allow editing when waiting for tech approval (for regular employees)
                      // Team leads can edit when waiting for HR approval
                      const userIsEmployee = user?.role?.code === "EMPLOYEE";
                      const userIsTeamLead = user?.role?.code === "TEAM LEAD";
                      const isOwner = row?.user?._id === user?._id;
                      
                      const canEdit = isOwner && (
                        (userIsEmployee && row?.status?.code === "waiting-tech-approval") ||
                        (userIsTeamLead && row?.status?.code === "waiting-hr-approval")
                      );
                      
                      if (canEdit) {
                        dispatch(openModal("ApplyForRemoteRequestModal", { ...row, isEdit: true }));
                      } else {
                        dispatch(openModal("ApplyForRemoteRequestModal", row));
                      }
                    })()
                  : ""
              }
            >
              {
                el[1] == null ? (<Td  icon={emptyIcon}  />)
                    :  

                  el[1][1] == null ? ( <Td icon={emptyIcon}  /> ) :

                     el[1][0] === "status" ? 
                      (tableName === "users" ? 
                        ( <Td text={setTextForm(el[1][1].name)} className={getStatus(el[1][1].name).className}/> )
                        : tableName === "remoteRequests" ?
                        ( <Td text={setTextForm(el[1][1].label)} className={getStatus(el[1][1].label).className}/> )
                        : 
                        (  <Td icon={getStatus(el[1][1].label).icon}
                               text={ 
                                setTextForm(
                                  row?.dateRejectRH ? "Rejected by RH" 
                                  : row?.dateRejectTL ? "Rejected by TL": el[1][1].label )
                           } 
                               className={getStatus(el[1][1].label).className}
                        />
                        )
                      ) : 
                     el[1][0] === "authorisationTime" && tableName === "authorisations" ?
                      ( <Td text={  "   From   " +  el[1][1]?.startTime + "   To   " +el[1][1]?.endTime }/> ) :
                     el[1][0] === "authorisationDate" && tableName === "authorisations" ? 
                      (<Td text={changeOneDateFormat(el[1][1].date)} />) :
                     el[1][0] === "leaveDate" ? 
                     ( <Td text={changeDateFormat(  el[1][1].dateStart,  el[1][1].dateEnd )} />
                ) :
                     el[1][0] === "remoteRequestDate" && tableName === "remoteRequests" ?
                     ( <Td text={changeDateFormat(el[1][1].startDate, el[1][1].endDate)} />
                ) : 

                el[0] === "dateStart" ? 
                  ( leaveDate.push(el[1]) && <Td style={{ display: "none" }} />) :
                el[0] === "dateEnd" ?
                 (leaveDate.push(el[1]) && (<Td text={changeDateFormat(leaveDate[0], leaveDate[1])} />)) :
                el[0] === "startDate" && tableName === "remoteRequests" ?
                  ( leaveDate.push(el[1]) && <Td style={{ display: "none" }} />) :
                el[0] === "endDate" && tableName === "remoteRequests" ?
                 (leaveDate.push(el[1]) && (<Td text={changeDateFormat(leaveDate[0], leaveDate[1])} />)) :
                  
              
                  el[1][0] === "userInfo" ? ( 
                      <>
                        <Td icon={emailIcon} text={el[1][1].email} />
                        <Td icon={telIcon} text={`+216 ${el[1][1].phone}`} />
                      </> ) : 
                  el[1][0] === "user" ? 
                      ( <Td icon={el[1][1].img ? el[1][1].img : <Avatar />}
                      text={el[1][1].fullName}  description={el[1][1].jobTitle}
                      className="user-name"  imgSize="user-img"
                    />
                      ) : 
                  el[1][0] === "type" ? (
                    <Td icon={getLeaveType(el[1][1]?.name).icon}
                      className={getLeaveType(el[1][1]?.name).className}
                      text={`${el[1][1]?.name} leave`}
                    />) :
                     tableName === "leave-types" ? (
                  el[1][0] === "img" ? (
                    <Td icon={el[1][1]} imgSize="leave-type-img" costumWidth />
                  ) : el[1][0] === "name" ? (
                    <Td text={el[1][1]} />
                  ) : el[1][0] === "preview" ? (
                    <Td
                      style={{ color: el[1][1].color }}
                      text={el[1][1].name}
                      icon={el[1][1].img ? el[1][1].img : <Avatar />}
                      imgSize="leave-type-img"
                    />
                  ) : (
                    ""
                  )
                     ) :
                  el[1][0] === "department" ? (
                    <Td text={`${el[1][1]?.name} Department`} />
                    ) :
                  el[1][0] === "authorisationLength" ? ( 
                    <>
                      <Td text={`${ el[1][1] + " " + pluralHandler(el[1][1], "Hour") }`}/>
                    </>
                    ) :
                  el[1][0] === "authorisationBalanceLeft" ? (
                    <>
                      {el[1][1] === null ? (
                        <Td icon={emptyIcon} />
                      ) : (
                        <Td text={`${ el[1][1] + " " + pluralHandler(el[1][1], "Hour") }`}/>
                      )}
                    </>
                  ) : 
                  el[1][0] === "hasReachedMonthlyLimit" ? (
                    <>
                      <Td 
                        text={el[1][1] ? "⚠️ Monthly Limit Reached" : "✅ Within Limit"}
                        className={el[1][1] ? "monthly-limit-warning" : "monthly-limit-ok"}
                        style={{
                          color: el[1][1] ? '#d32f2f' : '#2e7d32',
                          fontWeight: el[1][1] ? 'bold' : 'normal',
                          backgroundColor: el[1][1] ? '#ffebee' : '#e8f5e8',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px'
                        }}
                      />
                    </>
                  ) :
                  el[1][0] === "balanceStatus" && tableName === "authorisations" ? (
                    <>
                      <Td 
                        text={row.isUsed ? "🟢 Deducted" : "⏳ Pending"}
                        className={row.isUsed ? "balance-deducted" : "balance-pending"}
                        style={{
                          color: row.isUsed ? '#28a745' : '#ffc107',
                          fontWeight: '600',
                          backgroundColor: row.isUsed ? '#e8f5e8' : '#fff8e1',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px'
                        }}
                      />
                    </>
                  ) :
                  el[1][0] === "balance" || el[1][0] === "leaveLength" ? (
                  <>
                    <Td
                      text={`${
                        el[1][1] + " " + pluralHandler(el[1][1], "Day")
                      }`}
                    />
                  </>
                  ) :
                  el[1][0] === "dateApprovedTL" || el[1][0] === "dateApprovedRH" ||
                  el[1][0] === "dateRejectTL" ||el[1][0] === "dateRejectRH" || el[1][0] === "dateRejectNegotiation" ? 
                   ( el[1][1] ? <Td text={getFormattedDate(new Date(el[1][1]), "-")} /> : <Td icon={<span style={{color: '#ccc'}}>—</span>} /> )  :
                   (  <Td text={el[1][1]} /> )
              }
            </TableCell>
            {isAction && key === 2 && tableName === "leave-types" && (
              <TableCell>
                <div className="table-actions leavetypes-action">
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "LEAVE TYPE",
                    "VIEW"
                  ) && (
                    <div
                      className="edit-action"
                      onClick={() =>
                        dispatch(openModal("UpdateLeaveSettingsModal", row))
                      }
                    >
                      <img src={editIcon} alt="edit-icon" />
                    </div>
                  )}
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "LEAVE TYPE",
                    "DELETE"
                  ) && (
                    <div
                      className="delete-action"
                      onClick={() =>
                        dispatch(
                          openModal("confirm-delete-modal", {
                            id: row?._id,
                            Item: "leave type",
                            deleteHandler: deleteLeaveTypeHandler,
                          })
                        )
                      }
                    >
                      <img src={deleteIcon} alt="delete-icon" />
                    </div>
                  )}
                </div>
              </TableCell>
            )}
            {isAction === true && key === 5 && tableName === "headquarters" && (
              <TableCell>
                <div className="table-actions">
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "HEADQUARTER",
                    "EDIT"
                  ) && (
                    <div
                      className="edit-action"
                      onClick={() =>
                        dispatch(openModal("HeadquarterForm", { headquarter: row }))
                      }
                    >
                      <Tooltip title="Edit">
                        <img src={editIcon} alt="edit-icon" />
                      </Tooltip>
                    </div>
                  )}
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "HEADQUARTER",
                    "DELETE"
                  ) && (
                    <div
                      className="delete-action"
                      onClick={() => {
                        dispatch(
                          openModal("confirm-delete-modal",{
                            id: row?._id,
                            Item: "headquarter",
                            deleteHandler: async () => {
                              try {
                                await dispatch(deleteHeadquarter(row?._id)).unwrap();
                                toast.success("Headquarter deleted successfully");
                                dispatch(closeModal("confirm-delete-modal"));
                              } catch (error) {
                                toast.error(error.message || "Error deleting headquarter");
                              }
                            },
                            action: "delete",
                          })
                        )
                      }
                    }
                    >
                      <Tooltip title="Delete">
                        <img src={deleteIcon} alt="delete-icon" />
                      </Tooltip>
                    </div>
                  )}
                </div>
              </TableCell>
            )}
            {isAction === true && key === 5 && tableName !== "headquarters" && tableName !== "remoteRequests" && tableName !== "authorisations" && (
              <TableCell>
                <div className="table-actions">
                  {(() => {
                    const hasLeaveReject = getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "LEAVE",
                      "REJECT"
                    );
                    const hasNegotiationReject = getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "LEAVES NEGOTIATION",
                      "REJECT"
                    );
                    const hasAuthReject = getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "AUTHORISATION",
                      "REJECT"
                    );
                    const hasRemoteRequestReject = getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "REMOTE REQUEST",
                      "REJECT"
                    );
                    return hasLeaveReject || hasNegotiationReject || hasAuthReject || hasRemoteRequestReject;
                  })() ? (
                      <div
                        className="reject-action"
                        onClick={() => {
                          if (isMySpace) {
                            rejectNegotiationHandler();
                          } else if (tableName === "remoteRequests") {
                            dispatch(
                              openModal("RejectRemoteRequestModal", {
                                id: row?._id,
                                onReject: onReject,
                              })
                            );
                          } else {
                            dispatch(
                              openModal("RejectLeaveRequestModal", {
                                isLeaveOrAuthorisation: isAuthorisation
                                  ? true
                                  : false,
                                getLeaveStatus: getLeaveStatus,
                                id: row?._id,
                              })
                            );
                          }
                        }}
                      >
                        <Tooltip title="Reject">
                          <CloseIcon />
                        </Tooltip>
                      </div>
                  ) : (
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "LEAVE",
                      "DELETE"
                    ) ||
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "AUTHORISATION",
                      "DELETE"
                    ) ||
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "REMOTE REQUEST",
                      "DELETE"
                    ) ? (
                        <div
                        className="delete-action"
                        onClick={() => {
                          if (tableName === "remoteRequests") {
                            onDelete && onDelete(row._id);
                          } else {
                            dispatch(
                              openModal("confirm-delete-modal", {
                                id: row?._id,
                                Item: isAuthorisation ? "authorisation" : "leave",
                                deleteHandler: deleteLeaveHandler,
                                action: "delete",
                              })
                            );
                          }
                        }}
                      >
                        <Tooltip title="Delete">
                        <img src={deleteIcon} alt="delete-icon" />
                      </Tooltip>
                      </div>
                      ) : (
                        ""
                      )
                  )}

                  {/* {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "LEAVES NEGOTIATION",
                    "CREATE"
                  ) &&
                    tableName !== "authorisations" && (
                      <div
                        className="pending-action"
                        onClick={negotiateRequestHandler}
                      >
                        <Tooltip title="Negotiate">
                          <AccessTimeIcon />
                        </Tooltip>
                      </div>
                    )} */}
                  {(getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "LEAVE",
                    "APPROVE"
                  ) ||
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "LEAVES NEGOTIATION",
                      "APPROVE"
                    ) ||
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "AUTHORISATION",
                      "APPROVE"
                    ) ||
                    getAccess(
                      user?.permissions,
                      user?.permissionGroups?.[0]?.permissions,
                      "REMOTE REQUEST",
                      "APPROVE"
                    )) && (
                    <div
                      className="approve-action"
                      onClick={
                        isMySpace
                          ? acceptNegotiationHandler
                          : approveRequestHandler
                      }
                    >
                      <Tooltip title="Approve">
                        <DoneIcon />
                      </Tooltip>
                    </div>
                  )}
                </div>
              </TableCell>
            )}
            {isCollapsed === true && key === 3 && (
              <TableCell>
                <div className="collapse-btn" onClick={() => setOpen(!open)}>
                  <IconButton aria-label="expand row" size="small">
                    {open ? (
                      <KeyboardArrowUpIcon className="rowActions" />
                    ) : (
                      <KeyboardArrowDownIcon className="rowActions" />
                    )}
                  </IconButton>
                </div>
              </TableCell>
            )}
          </React.Fragment>
          );
        })}
        
        {/* Control Column (Approve/Reject Actions) - Only for remote requests */}
        {tableName === "remoteRequests" && isAction && (
          <TableCell>
            <div className="table-actions">
              {/* Approve Action */}
              {(userIsRH || userIsTeamLead) && (
                <div
                  className="approve-action"
                  onClick={() => {
                    if (tableName === "remoteRequests" && onApprove) {
                      onApprove(row._id);
                    } else {
                      approveRequestHandler();
                    }
                  }}
                >
                  <Tooltip title="Approve">
                    <DoneIcon />
                  </Tooltip>
                </div>
              )}

              {/* Reject Action */}
              {(userIsRH || userIsTeamLead) && (
                <div
                  className="reject-action"
                  onClick={() => {
                    if (tableName === "remoteRequests") {
                      dispatch(
                        openModal("RejectRemoteRequestModal", {
                          id: row?._id,
                          onReject: onReject,
                        })
                      );
                    } else {
                      dispatch(
                        openModal("RejectLeaveRequestModal", {
                          isLeaveOrAuthorisation: isAuthorisation ? true : false,
                          getLeaveStatus: getLeaveStatus,
                          id: row?._id,
                        })
                      );
                    }
                  }}
                >
                  <Tooltip title="Reject">
                    <CloseIcon />
                  </Tooltip>
                </div>
              )}
            </div>
          </TableCell>
        )}
        
        {/* Delete Column (Delete Action) - Only for remote requests */}
        {tableName === "remoteRequests" && isAction && (
          <TableCell>
            <div className="table-actions">
              {user?.role?.code === "SUPER ADMIN" && (
                <div
                  className="delete-action"
                  onClick={() => {
                    if (tableName === "remoteRequests" && onDelete) {
                      onDelete(row._id);
                    } else {
                      console.log("Delete action clicked for remote request:", row._id);
                    }
                  }}
                >
                  <Tooltip title="Delete">
                    <img src={deleteIcon} alt="delete-icon" />
                  </Tooltip>
                </div>
              )}
            </div>
          </TableCell>
        )}
        
        {/* Control Column for Authorisations */}
        {tableName === "authorisations" && isAction && (
          <TableCell>
            <div className="table-actions">
              {/* Show buttons only if user role matches the current status */}
              {(() => {
                const userRole = user?.role?.code;
                const currentStatus = row?.status?.code;
                
                // Team Lead can approve/reject when status is "waiting-tech-approval"
                const canTeamLeadAct = userRole === "TEAM LEAD" && currentStatus === "waiting-tech-approval";
                
                // RH can approve/reject when status is "waiting-hr-approval"  
                const canRHAct = userRole === "RH" && currentStatus === "waiting-hr-approval";
                
                // Super Admin can always act
                const canSuperAdminAct = userRole === "SUPER ADMIN";
                
                return canTeamLeadAct || canRHAct || canSuperAdminAct;
              })() && (
                <>
                  {/* Approve Button */}
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "AUTHORISATION",
                    "APPROVE"
                  ) && (
                    <div
                      className="approve-action"
                      onClick={approveRequestHandler}
                    >
                      <Tooltip title="Approve">
                        <DoneIcon />
                      </Tooltip>
                    </div>
                  )}

                  {/* Reject Button */}
                  {getAccess(
                    user?.permissions,
                    user?.permissionGroups?.[0]?.permissions,
                    "AUTHORISATION",
                    "REJECT"
                  ) && (
                    <div
                      className="reject-action"
                      onClick={() => {
                        dispatch(
                          openModal("RejectLeaveRequestModal", {
                            isLeaveOrAuthorisation: true,
                            getLeaveStatus: getLeaveStatus,
                            id: row?._id,
                          })
                        );
                      }}
                    >
                      <Tooltip title="Reject">
                        <CloseIcon />
                      </Tooltip>
                    </div>
                  )}
                </>
              )}

              {/* Delete Button - Only for Super Admin */}
              {user?.role?.code === "SUPER ADMIN" && getAccess(
                user?.permissions,
                user?.permissionGroups?.[0]?.permissions,
                "AUTHORISATION",
                "DELETE"
              ) && (
                <div
                  className="delete-action"
                  onClick={() => {
                    dispatch(
                      openModal("confirm-delete-modal", {
                        id: row?._id,
                        Item: "authorisation",
                        deleteHandler: deleteLeaveHandler,
                        action: "delete",
                      })
                    );
                  }}
                >
                  <Tooltip title="Delete">
                    <img src={deleteIcon} alt="delete-icon" />
                  </Tooltip>
                </div>
              )}
            </div>
          </TableCell>
        )}
      </TableRow>

      {isCollapsed && (
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, height: 0 }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <CollapseComponent setOpen={setOpen} open={open} row={row} />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
};

export default Row;
